/*
 * @Description: 游戏管理
 * @Author: gao shuai
 * @Date: 2020-04-13 09:32:14
 * @LastEditTime: 2020-06-11 15:00:07
 * @LastEditors: gao shuai
 */

import api from '../assets/js/apiRequestHandler';
import mgr from '../assets/js/securityapi';
export default {
  /* -----------------1.分组管理------------------- */
  // 分组列表
  async grouplist(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageGroup/GetGroupPageList',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 查看分区
  async groupcheck(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageGroup/GetPartitionByGroup',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 删除分区
  async groupdelete(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageGroup/DeleteGroup',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  /* -----------------2.分区管理------------------- */
  // 分区列表
  async gamelist(params) {
    let header = await mgr();
    return api({
      url: '/api/ManagePartition/GetPartitionPageList',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 游戏分组下拉
  async gamepull() {
    let header = await mgr();
    return api({
      url: '/api/ManagePartition/GetPartitionGroupList',
      method: 'get',
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 游戏分组下拉
  async gamedelete(params) {
    let header = await mgr();
    return api({
      url: '/api/ManagePartition/DeletePartition',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 充值域名获取
  async getnetarea(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageIndex/GetCircuiteAsync',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 分区检测
  async checkLink(params) {
    let header = await mgr();
    return api({
      url: '/api/ManagePartition/CheckPartition',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  }
};
